import classNames from 'classnames'
import { BreakoutTooltip } from 'components/design-system/BreakoutTooltip'
import { Shield } from 'components/icons/Shield'
import { useTranslationTyped } from 'i18n/i18n'

export function AppealOverrideIndicator({ className }: { className?: string }) {
  const { tt } = useTranslationTyped()
  const label = tt.appeal_override.tooltip()

  return (
    <BreakoutTooltip content={label}>
      <span
        aria-label={label}
        className={classNames(
          'focus-ring-floating inline-flex shrink-0 items-center justify-center rounded-sm text-fixed-teal',
          className
        )}
        data-testid="appeal-override-indicator"
        role="img"
        tabIndex={0}
      >
        <Shield size={14} />
      </span>
    </BreakoutTooltip>
  )
}

export function AppealOverrideLegend({ className }: { className?: string }) {
  const { tt } = useTranslationTyped()

  return (
    <div
      className={classNames(
        'flex flex-row items-center gap-2 px-2 text-body-small text-on-surface-var',
        className
      )}
      data-testid="appeal-override-legend"
    >
      <Shield className="text-fixed-teal" size={14} />
      <div>{tt.appeal_override.legend()}</div>
    </div>
  )
}
